import _JSXStyle from "styled-jsx/style";
import { Checkbox } from '@dhis2-ui/checkbox';
import { colors, spacers } from '@dhis2/ui-constants';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
// Padding has to be set on the label, so that the entire area is clickable
const {
  styles,
  className: checkboxClassname
} = {
  styles: /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2013783366"
  }, [".jsx-2013783366{padding:".concat(spacers.dp8, " ").concat(spacers.dp12, ";}")]),
  className: "jsx-2013783366"
};

const MultiSelectOption = _ref => {
  let {
    label,
    active,
    disabled,
    onClick,
    className,
    dataTest,
    value
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    "data-value": value,
    "data-label": label,
    className: _JSXStyle.dynamic([["3813980210", [colors.grey200]]]) + " " + (cx(className, {
      disabled
    }) || "")
  }, /*#__PURE__*/React.createElement(Checkbox, {
    name: label,
    className: checkboxClassname,
    checked: active,
    label: label,
    onChange: onClick,
    disabled: disabled,
    dense: true
  }), styles, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3813980210",
    dynamic: [colors.grey200]
  }, ["div.__jsx-style-dynamic-selector:hover{background-color:".concat(colors.grey200, ";}"), "div.disabled.__jsx-style-dynamic-selector:hover{background-color:initial;}"]));
};

MultiSelectOption.defaultProps = {
  dataTest: 'dhis2-uicore-multiselectoption'
};
MultiSelectOption.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  active: PropTypes.bool,
  className: PropTypes.string,
  dataTest: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};
export { MultiSelectOption };